import {
  DietModeType,
  DietSpontaneousActivityLevelType,
  DietActivityLevelType,
} from '@front-activerse/common-components';
import { validateVariablesType } from '../types';

const createRequest = (values: any) => {
  const {
    weightValue,
    weightUnit,
    dietMode,
    goalWeightUnit,
    goalWeightValue,
    spontaneousActivityLevel,
    activityLevel,
    preferredMacronutrientRatio,
  } = values;

  const calculateGoalWeight = () => {
    if (dietMode === null && dietMode === null) {
      return { value: weightValue, unit: weightUnit };
    } else if (dietMode !== DietModeType.stabilization) {
      if (goalWeightValue) {
        return { value: goalWeightValue, unit: goalWeightUnit };
      } else {
        return null;
      }
    } else {
      return { value: weightValue, unit: weightUnit };
    }
  };

  const goalWeight = calculateGoalWeight();

  const variables: validateVariablesType = {
    weight: weightValue ? { value: weightValue, unit: weightUnit } : null,
    dietMode: dietMode ? dietMode : DietModeType.stabilization,
    goalWeight,
    spontaneousActivityLevel: spontaneousActivityLevel
      ? spontaneousActivityLevel
      : DietSpontaneousActivityLevelType.SPONTANEOUS_ACTIVITY_LEVEL_NONE,
    activityLevel: activityLevel ? activityLevel : DietActivityLevelType.ACTIVITY_LEVEL_NONE,
    preferredMacronutrientRatio: {
      protein: preferredMacronutrientRatio.protein,
      fat: preferredMacronutrientRatio.fat,
      carbohydrate: preferredMacronutrientRatio.carbohydrate,
    },
  };

  return variables;
};

export default createRequest;
